import { trackPopupOpen } from "../services/analytics";

/**
 * Logs popup opens for analytics, including raw `dispatch({ type: "SHOW_POPUP", ... })`.
 */
export function analyticsPopupMiddleware() {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case "SHOW_POPUP":
          if (action.payload != null && action.payload !== false) {
            trackPopupOpen(String(action.payload).trim()).catch(function () {});
          }
          break;
        case "SHOW_VALIDATION_POPUP": {
          var d = action.payload || {};
          var sub =
            d.type != null ? String(d.type).trim().slice(0, 48) : "";
          trackPopupOpen(sub ? "validation:" + sub : "validation").catch(
            function () {}
          );
          break;
        }
        case "SHOW_FORGOT_PASSWORD_POPUP":
          trackPopupOpen("forgot_password").catch(function () {});
          break;
        case "SHOW_CHECK_EMAIL_POPUP":
          trackPopupOpen("check_email").catch(function () {});
          break;
        case "SHOW_RESET_PASSWORD_POPUP":
          trackPopupOpen("reset_password").catch(function () {});
          break;
        case "SHOW_PASSWORD_RESET_SUCCESS_POPUP":
          trackPopupOpen("password_reset_success").catch(function () {});
          break;
        default:
          break;
      }
      return next(action);
    };
  };
}
